import { Type } from '@angular/core';
import { checkIfControlIsAlreadyPresentByName } from './helpers';
import { DxFormGroup } from '../form-group';
import { FORM_GROUP_METADATA_KEY } from './metadata-keys';
import { DxFormGroupDefinition } from './interfaces';
import { addToMetadata } from '@digitaix/helpers';

export function FormGroup(group: Type<DxFormGroup<any, any, any>>) {
  return function(target: any, propertyKey: string) {
    const definition: DxFormGroupDefinition<any> = {
      name: propertyKey,
      propertyKey,
      group
    };
    if (
      checkIfControlIsAlreadyPresentByName(
        FORM_GROUP_METADATA_KEY,
        target,
        definition.name
      )
    ) {
      throw new Error(
        `[FormGroup::${propertyKey}] A FormGroup with name '${
          definition.name
        }' is already defined`
      );
    }
    addToMetadata(FORM_GROUP_METADATA_KEY, definition, target);
  };
}
